import { FormHelperText, TextField, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { ChangeEvent, FC, useEffect, useState } from 'react';
import { useDictionary, useIsDesktop } from 'Hooks';
import { illegalChars } from 'Regex';
import { NEW_PAGE_THOUGHTS, THOUGHTS } from 'Enum/Feedback';
export interface INote {
  value: string;
  onChange: (value: string) => void;
  thoughtsValue: string;
  error: boolean;
  setError: (value: boolean) => void;
}

const MAX_LENGTH = 500;

export const Note: FC<INote> = ({
  value,
  onChange,
  thoughtsValue,
  error,
  setError,
}) => {
  const [title, setTitle] = useState<string>('');
  const [placeholder, setPlaceholder] = useState<string>('');

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback).note;

  useEffect(() => {
    switch (thoughtsValue) {
      case THOUGHTS.improvement:
        setTitle(dictionary.howToImprove);
        setPlaceholder(dictionary.howToImprovePlaceholder);
        break;
      case THOUGHTS.problem:
        setTitle(dictionary.whatIsTheProblem);
        setPlaceholder(dictionary.whatIsTheProblemPlaceholder);
        break;
      case THOUGHTS.like:
        setTitle(dictionary.details);
        setPlaceholder(dictionary.detailsPlaceholder);
        break;
      case NEW_PAGE_THOUGHTS.other:
        setTitle(dictionary.whatIsTheProblem);
        setPlaceholder(dictionary.whatIsTheProblemPlaceholder);
        break;
      default:
        setTitle('');
        setPlaceholder('');
        break;
    }
    setError(false);
  }, [thoughtsValue]);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onChange(e.target.value);
    setError(e.target.value.trim().length === 0);
  };

  return (
    <>
      <Typography variant={'body2'} component='label' htmlFor='request-note'>
        {title}
      </Typography>
      <TextField
        id='request-note'
        aria-describedby={error ? 'request-note-error' : undefined}
        multiline
        rows={4}
        variant='outlined'
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onInput={(e: ChangeEvent<HTMLInputElement>) => {
          e.target.value = e.target.value
            .replace(illegalChars, '')
            .slice(0, MAX_LENGTH);
        }}
        inputProps={{
          maxLength: MAX_LENGTH,
        }}
        onBlur={() => {
          setError(value.trim() === '');
        }}
        error={!!error}
        helperText={`${value.length}/${MAX_LENGTH}`}
        fullWidth
        margin='normal'
        required
        InputProps={{
          style: {
            background: '#fff',
            border: error ? '1px solid #ec0000' : '1px solid #B7CCFF',
            borderRadius: '8px',
            marginBottom: '8px',
            paddingBottom: '30px',
          },
          'aria-describedby': undefined,
        }}
        FormHelperTextProps={{
          style: {
            color: error ? '#ec0000' : '#A020FF',
            textAlign: 'left',
            fontWeight: value.length === MAX_LENGTH ? 'bold' : undefined,
            marginLeft: '26px',
            marginTop: isDesktop ? '-2px' : '-4px',
          },
          'aria-hidden': true,
        }}
        sx={{
          '& .MuiInputBase-input': {
            zIndex: 9,
            paddingLeft: '1px',
          },
          '& .MuiFormHelperText-root': {
            position: 'relative',
            top: isDesktop ? '-40px' : '-30px',
            fontSize: isDesktop ? '18px' : '14px',
            zIndex: 0,
          },
          '.MuiOutlinedInput-notchedOutline': { border: 'none' },
          '& ::placeholder': {
            color: '#A6ACBC !important',
          },
        }}
      />
      {!!error && (
        <FormHelperText
          role='alert'
          aria-live='assertive'
          error={true}
          id={'request-note-error'}
          sx={{ m: '-38px 0 18px 16px', fontSize: '18px' }}
        >
          {dictionary.errorMessage}
        </FormHelperText>
      )}
    </>
  );
};
